import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5S1.5 11.59 1.5 8 4.41 1.5 8 1.5M8 16a8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8 8 8 0 0 0 8 8M6.64 4.61a.747.747 0 0 0-1.14.64v5.5a.75.75 0 0 0 1.144.637l4.5-2.75a.75.75 0 0 0 .36-.64.75.75 0 0 0-.36-.64l-4.5-2.75zM9.314 8 7 9.412V6.587z" />
  </svg>
);
export default SvgPlay;
